export default __webpack_public_path__ + "static/media/01en.319c24ee.mp3";